import React, { Fragment } from "react";

const LoaderButton = ({ text, isLoading, loaderText, children, ...props }) => {
  return (
    <button
      type="button"
      {...props} // spread props directly to <button>
      disabled={isLoading || props.disabled}
    >
      {isLoading ? (
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <i className="fas fa-spinner fa-spin"></i>
          <span> {` ${loaderText || text}`}</span>
        </span>
      ) : (
        <Fragment>{text || children}</Fragment>
      )}
    </button>
  );
};

export default LoaderButton;
